import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['input', 'submit']

    vote({ detail }) {
        if (this.hasInputTarget) {
            this.inputTarget.value = parseInt(detail);
        }

        this.element.classList.add('show');
    }

    cancel() {
        if (this.hasInputTarget) {
            this.inputTarget.value = '';
        }

        this.element.classList.remove('show');
    }

    close() {
        this.cancel();
    }

    esc(e) {
        if (e instanceof KeyboardEvent) {
            this.cancel();
        }
    }

    submitTargetConnected(element) {
        const form = element.closest('form');

        const checkValidity = (function checkValidity() {
            if (form.checkValidity()) {
                element.removeAttribute('disabled');
            } else {
                element.setAttribute('disabled', '');
            }

            return checkValidity;
        })();

        for (const input of form.querySelectorAll('input, select, textarea')) {
            input.addEventListener('blur', () => {
                checkValidity();
            });

            input.addEventListener('change', () => {
                checkValidity();
            });

            input.addEventListener('keyup', () => {
                checkValidity();
            });
        }
    }
}
